import { request } from '../utils/httpClient';

export const getSPDChaptersList = (data) => {
  let url = `/membership/spd_chapters?page_size=${data.rowsPerPage}&page=${data.page}`;
  if (data.search) {
    url += `&search=${data.search}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  return request({
    url: url,
    method: 'GET',
  });
};

export const getLCChaptersList = (data) => {
  let url = `/membership/local_chapters?page_size=${data.rowsPerPage}&page=${data.page}`;
  if (data.spd) {
    url += `&spd_chapter_id=${data.spd}`;
  }
  if (data.status !== 'all') {
    url += `&status=${data.status}`;
  }
  if (data.search) {
    url += `&search=${data.search}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  return request({
    url: url,
    method: 'GET',
  });
};

export const getSpdDetail = (data) => {
  return request({
    url: `/membership/spd_chapters/${data.id}`,
    method: 'GET',
  });
};

export const getSpdInfo = (data) => {
  return request({
    url: `/membership/spd_chapters/${data.id}/info`,
    method: 'GET',
  });
};

export const getSPDChapterTypes = () => {
  return request({
    url: `/membership/spd_chapters/chapter_types`,
    method: 'GET',
  });
};

export const getSPDSponsers = () => {
  return request({
    url: `/membership/spd_chapters/sponsors`,
    method: 'GET',
  });
};

export const getSPDRegions = () => {
  return request({
    url: `/membership/spd_chapters/regions`,
    method: 'GET',
  });
};

export const patchSpdInfo = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/membership/spd_chapters/${formId}/info`,
    method: 'PATCH',
    data: data,
  });
};

export const getSPDLeadership = (data) => {
  return request({
    url: `/membership/spd_chapters/${data.id}/leadership`,
    method: 'GET',
  });
};

export const getSPDLeadershipPositions = () => {
  return request({
    url: `/membership/spd_assistant_positions`,
    method: 'GET',
  });
};

export const patchSPDLeadership = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/membership/spd_chapters/${formId}/leadership`,
    method: 'PATCH',
    data: data,
  });
};

export const postSPDLeadership = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/membership/spd_chapters/${formId}/leadership`,
    method: 'POST',
    data: data,
  });
};

export const replaceExistingLeadership = (data) => {
  let formId = data.formId;
  let leadershipId = data.id;
  delete data.formId;
  delete data.id;
  return request({
    url: `/membership/spd_chapters/${formId}/leadership/${leadershipId}`,
    method: 'POST',
    data: data,
  });
};

export const deleteSPDLeadership = (data) => {
  return request({
    url: `/membership/spd_chapters/${data.formId}/leadership/${data.id}`,
    method: 'DELETE',
  });
};

export const getSPDCommittees = (data) => {
  return request({
    url: `/membership/spd_chapters/${data.id}/committees`,
    method: 'GET',
  });
};

export const getCommitteePositions = () => {
  return request({
    url: `/membership/committee_positions`,
    method: 'GET',
  });
};

export const patchSPDCommittees = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/membership/spd_chapters/${formId}/committees`,
    method: 'PATCH',
    data: data,
  });
};

export const postSPDCommittees = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/membership/spd_chapters/${formId}/committees`,
    method: 'POST',
    data: data,
  });
};

export const replaceExistingCommittees = (data) => {
  let formId = data.formId;
  let leadershipId = data.id;
  delete data.formId;
  delete data.id;
  return request({
    url: `/membership/spd_chapters/${formId}/committees/${leadershipId}`,
    method: 'POST',
    data: data,
  });
};

export const deleteSPDCommittees = (data) => {
  return request({
    url: `/membership/spd_chapters/${data.formId}/committees/${data.id}`,
    method: 'DELETE',
  });
};

export const getSPDReciprocity = (data) => {
  return request({
    url: `/membership/spd_chapters/${data.id}/reciprocity`,
    method: 'GET',
  });
};

export const getLCDetail = (data) => {
  return request({
    url: `/membership/local_chapters/${data.id}`,
    method: 'GET',
  });
};

export const getLCInfo = (data) => {
  return request({
    url: `/membership/local_chapters/${data.id}/info`,
    method: 'GET',
  });
};

export const getLCMembers = (data) => {
  let url = `/membership/local_chapters/${data.id}/members`;
  if (data.userType) {
    url += `?type=${data.userType}`;
  }
  if (data.dateSince) {
    url += `&date_since=${data.dateSince.format('YYYY-MM-DD')}`;
  }
  return request({
    url: url,
    method: 'GET',
  });
};

export const getLCLeadership = (data) => {
  return request({
    url: `/membership/local_chapters/${data.id}/leadership`,
    method: 'GET',
  });
};

export const patchLCLeadership = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/membership/local_chapters/${formId}/leadership`,
    method: 'PATCH',
    data: data,
  });
};

export const postLCLeadership = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/membership/local_chapters/${formId}/leadership`,
    method: 'POST',
    data: data,
  });
};

export const replaceExistingLCLeadership = (data) => {
  let formId = data.formId;
  let leadershipId = data.id;
  delete data.formId;
  delete data.id;
  return request({
    url: `/membership/local_chapters/${formId}/leadership/${leadershipId}`,
    method: 'POST',
    data: data,
  });
};

export const deleteLCLeadership = (data) => {
  return request({
    url: `/membership/local_chapters/${data.formId}/leadership/${data.id}`,
    method: 'DELETE',
  });
};

export const getLCCommittees = (data) => {
  return request({
    url: `/membership/local_chapters/${data.id}/committees`,
    method: 'GET',
  });
};

export const getReciprocityTypes = () => {
  return request({
    url: `/resources/reciprocity/types`,
    method: 'GET',
  });
};

export const getReciprocityPositions = () => {
  return request({
    url: `/membership/reciprocity_positions`,
    method: 'GET',
  });
};

export const getReciprocityList = (data) => {
  let url = `/resources/reciprocity?page_size=${data.rowsPerPage}&page=${data.page}`;
  if (data.search) {
    url += `&search=${data.search}`;
  }
  if (data.orderBy) {
    url += `&order_by=${data.orderBy}`;
  }
  if (data.order) {
    url += `&order=${data.order}`;
  }
  if (data.reciprocityType && data.reciprocityType !== 'all') {
    url += `&reciprocity_type=${data.reciprocityType}`;
  }
  return request({
    url: url,
    method: 'GET',
  });
};

export const getOverseasContacts = () => {
  return request({
    url: '/membership/overseas/reciprocity',
    method: 'GET',
  });
};

export const getReciprocityDetail = (data) => {
  return request({
    url: `/resources/reciprocity/${data.id}`,
    method: 'GET',
  });
};

export const patchRCRoles = (data) => {
  let formId = data.formId;
  let roleId = data.id;
  delete data.formId;
  delete data.id;
  return request({
    url: `/resources/reciprocity/${formId}/roles/${roleId}`,
    method: 'PATCH',
    data: data,
  });
};

export const postRCRoles = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/reciprocity/${formId}`,
    method: 'POST',
    data: data,
  });
};

export const replaceExistingRCRole = (data) => {
  let formId = data.formId;
  let leadershipId = data.id;
  delete data.formId;
  delete data.id;
  return request({
    url: `/resources/reciprocity/${formId}/roles/${leadershipId}`,
    method: 'POST',
    data: data,
  });
};

export const deleteRCRoles = (data) => {
  return request({
    url: `/resources/reciprocity/${data.formId}/roles/${data.id}`,
    method: 'DELETE',
  });
};

export const addRCChapter = (data) => {
  return request({
    url: `/resources/reciprocity/${data.id}/chapters/${data.chapterId}`,
    method: 'POST',
  });
};

export const removeRCChapter = (data) => {
  return request({
    url: `/resources/reciprocity/${data.id}/chapters/${data.chapterId}`,
    method: 'DELETE',
  });
};

export const patchReciprocity = (data) => {
  let formId = data.formId;
  delete data.formId;
  return request({
    url: `/resources/reciprocity/${formId}`,
    method: 'PATCH',
    data: data,
  });
};
